import schoollogo from '../assets/schoolloga.jpeg';
import img1 from '../assets/school.jpg';
import img2 from '../assets/WhatsApp Image 2026-04-07 at 10.25.20 AM.jpeg';
import img3 from '../assets/WhatsApp Image 2026-04-07 at 10.25.21 AM.jpeg';
import img4 from '../assets/WhatsApp Image 2026-04-07 at 10.25.22 AM.jpeg';
import img5 from '../assets/WhatsApp Image 2026-04-07 at 10.25.23 AM.jpeg';
import img6 from '../assets/WhatsApp Image 2026-04-07 at 10.25.23 AM (1).jpeg';
import img7 from '../assets/WhatsApp Image 2026-04-07 at 10.25.23 AM (2).jpeg';
import img8 from '../assets/WhatsApp Image 2026-04-07 at 10.25.24 AM.jpeg';
import img9 from '../assets/WhatsApp Image 2026-04-07 at 10.25.24 AM (1).jpeg';
import img10 from '../assets/WhatsApp Image 2026-04-07 at 10.25.25 AM.jpeg';
import img11 from '../assets/WhatsApp Image 2026-04-07 at 10.25.25 AM (1).jpeg';
import img12 from '../assets/WhatsApp Image 2026-04-07 at 10.25.26 AM.jpeg';

const images = [img2,img3,img4,img5,img6,img7,img8,img9,img10,img11,img12];

function Gallery() {
  return (
    <div style={{ padding: '60px 40px', maxWidth: '1100px', margin: '0 auto' }}>

      {/* School Building & Logo at Top */}
      <div style={{ textAlign: 'center', marginBottom: '50px' }}>
        <img src={schoollogo} alt="School Logo" style={{
          height: '120px',
          width: '120px',
          borderRadius: '50%',
          objectFit: 'cover',
          border: '4px solid #1a6b3c',
          marginBottom: '20px'
        }} />
        <h1 style={{ color: '#1a6b3c', fontSize: '32px', marginBottom: '20px' }}>
          Srilakshmi Matric High School
        </h1>
        <img src={img1} alt="School Building" style={{
          width: '100%',
          height: '450px',
          objectFit: 'cover',
          borderRadius: '16px',
          boxShadow: '0 8px 30px rgba(0,0,0,0.15)'
        }} />
      </div>

      {/* Gallery Title */}
      <h2 style={{ color: '#1a6b3c', fontSize: '30px', marginBottom: '10px' }}>📸 Gallery</h2>
      <p style={{ color: '#555', fontSize: '17px', marginBottom: '40px' }}>
        A glimpse into life at Srilakshmi Matric High School.
      </p>

      {/* Scrolling Strip */}
      <div style={{ overflow: 'hidden', marginBottom: '40px' }}>
        <style>{`
          @keyframes scroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .scroll-track {
            display: flex;
            gap: 16px;
            animation: scroll 20s linear infinite;
            width: max-content;
          }
          .scroll-track:hover {
            animation-play-state: paused;
          }
        `}</style>
        <div className="scroll-track">
          {[...images, ...images].map((img, i) => (
            <img key={i} src={img} alt={`School ${i}`} style={{
              height: '200px',
              width: '300px',
              objectFit: 'cover',
              borderRadius: '10px',
              flexShrink: 0
            }} />
          ))}
        </div>
      </div>

      {/* Photo Grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
        gap: '20px'
      }}>
        {images.map((img, i) => (
          <div key={i} style={{
            borderRadius: '12px',
            overflow: 'hidden',
            boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
            transition: 'transform 0.2s'
          }}
            onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.03)'}
            onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
          >
            <img src={img} alt={`School ${i + 1}`} style={{
              width: '100%',
              height: '200px',
              objectFit: 'cover',
              display: 'block'
            }} />
          </div>
        ))}
      </div>

    </div>
  );
}

export default Gallery;